const HEALTH_CHECK = '/healthcheck';
const SETTINGS = '/settings';
const COOKIE = '/cookie';
const STATISTIC = '/statistic';
const TRANSLATION = '/translation';

export { HEALTH_CHECK, SETTINGS, COOKIE, STATISTIC, TRANSLATION };
